export enum RequestType {
  cloud = 0,
  demoAsset = 1
}

export interface SupportRequestDto {
  requestType: RequestType;
  description: string;
}
